import { Box, Button, Typography } from "@mui/material";
import React from "react";
import EqualizerRoundedIcon from "@mui/icons-material/EqualizerRounded";

const DiscoverMore = () => {
  return (
    <Box sx={{ display: "flex", bgcolor: "#E8F5FF", px: 5, pt: 5, pb: 1 }}>
      <Box sx={{ mx: 20, p: 15 }}>
        <Typography sx={{ fontWeight: 600, fontSize: 30, lineHeight: 1.25 }}>
          Enhance Your School Management
        </Typography>
        <Typography sx={{ py: 3 }}>
          Discover the key features that make Helpsoo the best choice for
          managing your school.
        </Typography>
        <Button
          variant="contained"
          sx={{ py: 1.5, fontWeight: 600, textTransform: "none", fontSize: 16 }}
        >
          Discover More
        </Button>
      </Box>
      <Box sx={{ bgcolor: "#C2DFFB" }}>
        <Box
          sx={{
            bgcolor: "#9DC8F7",
            position: "relative",
            top: "55%",
            p: 4,
            left: "-4rem",
          }}
        >
          <EqualizerRoundedIcon sx={{ width: 40, height: 40 }} />
          <Typography fontSize={35} fontWeight={600}>
            1200+
          </Typography>
          <Typography>Schools using Helpsoo successfully</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default DiscoverMore;
